$.defaultTableOptions = function(tableID) {
	var options = new Object();
	
	options.sorting = [[0, 'asc']];
	options.buttons = [];
	options.pageSize = 10;
	options.emptyTableText = "No data available in table";
	options.rowCountID = tableID + 'RowCount';
	options.paginationID = tableID + 'Pagination';
	options.filterID = tableID + 'Filter';
	options.filterInputID = tableID + 'FilterInput';
	options.rowCallback = null;
	options.drawCallback = null;
	options.colReorder = false;
	
	return options;
};

$.initializeTable = function(tableID, columns, data, options) {
	
	if (!tableID || !columns ) {
		return false;
	}
	
	if (!data) {
		data = [];
	}
	
	if (!options) {
		options = $.defaultTableOptions();
	}
	
	if (!options.dom) {
		options.dom = 'Rt<"' + options.rowCountID + '"l><"' + options.paginationID + '"p>B';
	}
		
	// If page size count in storage...
	var pageSize = sessionStorage.getItem(options.rowCountID);
	if (!pageSize) {
		pageSize = options.pageSize;
	}
	
    var table = $(tableID).DataTable({       
        "processing": false,
        "autoWidth" : false,
        "deferRender" : true,
        "sorting": options.sorting,
        "data": data,
        "columns": columns,
        "dom" : options.dom,
        "paginationType" : "full_numbers",
        "displayLength" : pageSize,
        "paginate" : true,
        "lengthChange" : true,
        "buttons" : options.buttons,
        "language" : {
            "emptyTable": options.emptyTableText,
            "paginate" : {
                "first" : firstPaginationText,
                "previous" : previousPaginationText,
                "next" : nextPaginationText,
                "last" : lastPaginationText
            },
            "lengthMenu": showLabelText + '<select>' +
            '<option value="10">' + count10Text + '</option>' +
            '<option value="25">' + count25Text + '</option>' +
            '<option value="50">' + count50Text + '</option>' +
            '<option value="100">' + count100Text + '</option>' +
            '<option value="500">' + count500Text + '</option>' +
            '<option value="-1">' + countAllText + '</option>' +
            '</select>' + entriesLabelText
        },
        "colReorder" : options.colReorder,
        "stateSave" : true,
        "stateSaveCallback" : function(settings, data) {
            localStorage.setItem(tableID.substring(1) + '_' + settings.sInstance, JSON.stringify(data));
        },
        "stateLoadCallback" : function(settings) {
            return $.fn.loadTableState(settings, tableID.substring(1) + '_', options.filterInputID);
        },
        "initComplete" : function(settings, json) {
        	var rowCountWidget = $(options.rowCountID);
            rowCountWidget.addClass('row-count');

            var selectElement = rowCountWidget.find('select');
            $(selectElement).attr('data-sessionStorageID', options.rowCountID);
            $(selectElement).on('change', function(){
            	var value = $(this).val();
            	var item = $(this).attr('data-sessionStorageID');
            	sessionStorage.setItem(item, value);
            });
            
            var paginationWidget = $(options.paginationID);
            paginationWidget.addClass('pagination');
            $(tableID).trigger('tableInitialized');
        },
        "rowCallback" : options.rowCallback,
        "drawCallback" : options.drawCallback
    });
    
    $(tableID).on('click', 'tbody > tr', $.singleRowSelectionHandler);

    $(options.filterID).click($.handleFilterClicked);
    $(options.filterInputID).keyup(function() {
        $.filterTable(table, $(this).val());
    });
    
    return table;
};

$.fn.loadTableState = function(settings, prefix, filterID) {
    var tableState = JSON.parse(localStorage.getItem(prefix + settings.sInstance));
    
    if (!!tableState && !!tableState.search && !!tableState.search.search) {
        if (!!filterID) {
            var $filterInput = $(filterID);
            var $filterWrapper = $filterInput.closest('.filter-wrapper');
            var $filterIcon = $filterWrapper.find('i');
            
            $filterWrapper.addClass('open');
            $filterInput.val(tableState.search.search);
            $filterIcon.removeClass('fa-filter');
            $filterIcon.addClass('fa-times');
        } else {
            tableState.search.search = '';
        }
    }
    
    return tableState;
};